import { Injectable } from '@angular/core';
import { McticHttpClient } from '@mctic/ng-core';
import { Observable } from 'rxjs';
import { publishReplay, refCount } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class VersaoService {

  private _versao: Observable<any>;

  constructor(private readonly http: McticHttpClient) {
  }

  obterVersaoBackend(): Observable<any> {
    if (!this._versao) {
      this._versao = this.http
        .get<any>('/sepin-backend/rest/versao')
        .pipe(publishReplay(1), refCount());
    }

    return this._versao;
  }

}
